import { useNavigate, useLocation } from "react-router-dom";
import { getNavKeyFromPath } from "../../../utilities/systemAdminNavigation";
import { Nav } from '@fluentui/react/lib/Nav';

/**
 * Renders a collection of primary navigation items 
 * that can route to different paths in the app
 * 
 * @param {object[]} navGroups - an array of nav groups the user is authorized to see 
 * @returns - a fluentui Nav component
 */
export const PrimaryNav = ({navGroups}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location && location.pathname ? location.pathname : null; 

    function onLinkClick(ev, item) {
        ev.stopPropagation();
        ev.nativeEvent.stopImmediatePropagation();

        navigate({ pathname: item.path });
    }

    return (
        <Nav
            className="cw-PrimaryNav"
            selectedKey={getNavKeyFromPath(path)}
            groups={navGroups}
            onLinkClick={onLinkClick}
        />
    );
}
